//-------------------------------------------------------------------------------------------------- Imports
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "antd";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import InfoCardComponent from "../../components/InfoCardComponent";
import ListComponent, {
  ListComponentData,
} from "../../components/ListComponent";
import Loading from "../../components/Loading";
import { AppDispatch } from "../../stores/store";
import {
  getInternetSeguroProfile,
  getParentalControlEntitlement,
  selectHasParentalControlEntitlement,
} from "../../stores/slices/internetSeguroSlice";
import { StyleSheet } from "../../StyleSheet";

//-------------------------------------------------------------------------------------------------- View
const ParentalControlHome = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const hasProfile = useSelector(
    (state: any) => state.internetSeguro.hasProfile,
  );
  const loaded = useSelector((state: any) => state.internetSeguro.loaded);
  const entitlementLoaded = useSelector(
    (state: any) => state.internetSeguro.parentalControlEntitlementLoaded,
  );
  const hasParentalControlEntitlement = useSelector(
    selectHasParentalControlEntitlement,
  );

  // getInternetSeguroProfile solo llama a hasProfile si ya hay entitlement
  // (ver el propio thunk en internetSeguroSlice.tsx), por eso se espera el
  // entitlement primero en vez de dispararlos en paralelo.
  useEffect(() => {
    (async () => {
      await dispatch(getParentalControlEntitlement());
      await dispatch(getInternetSeguroProfile());
    })();
  }, [dispatch]);

  const isLoading = !loaded || !entitlementLoaded;
  const hasService = hasParentalControlEntitlement && hasProfile === true;

  const optionsArray: ListComponentData[] = hasService
    ? [
        { title: "Usuarios", subtitle: "" },
        { title: "Dispositivos", subtitle: "" },
      ]
    : [{ title: "Contratar Control Parental", subtitle: "" }];

  const goToRoute = (element: ListComponentData) => {
    if (element.title === "Usuarios") {
      navigate("/parental-control/users");
      return;
    }
    if (element.title === "Dispositivos") {
      navigate("/parental-control/devices");
      return;
    }
    if (element.title === "Contratar Control Parental") {
      navigate("/my-services");
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <SubDefaultLayout title={"Control Parental"}>
      <Row style={styles.rowPrincipal}>
        <Col xs={16} xl={12} style={{ paddingLeft: 10 }}>
          {!hasService && (
            <InfoCardComponent
              color="#c5d5e4"
              title="Aún no cuentas con Mega Control Parental"
              description="Contrátalo para administrar usuarios y dispositivos."
            />
          )}
          <div style={{ marginTop: 20 }}>
            <ListComponent
              arrayList={optionsArray}
              onPress={(option: ListComponentData) => goToRoute(option)}
            />
          </div>
        </Col>
      </Row>
    </SubDefaultLayout>
  );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
  rowPrincipal: {
    marginTop: 30,
    display: "flex",
    justifyContent: "center",
  },
});

//-------------------------------------------------------------------------------------------------- Exports
export default ParentalControlHome;
